export const config = {
    serverUrl: "https://test-nscmf.eonlineworkshop.com",
    imgUrl: "https://dh.eonlineworkshop.com/",
    zoomSdkKey: "Egz3OjF7ITKvLvhHxRhxLNa5us9uJQ24oJX7",
    razorAppKey: "rzp_live_yxYVhNWAkRzybF",
    geoKey: "AIzaSyBeeIWUhRhc2ZW9oKxUugzu8y9JQgFVcvA",
};
